/* src/app/table/table.component.css */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
:host {
  display: block;
  height: 100%;
  min-height: 0;
  font-size: 13px;
  line-height: 1.3em;
}
:host ::ng-deep .p-component:focus,
:host ::ng-deep .p-component *:focus,
:host ::ng-deep .p-paginator *:focus,
:host ::ng-deep .p-paginator .p-link:focus,
:host ::ng-deep .p-paginator button:focus,
:host ::ng-deep .p-paginator a:focus,
:host ::ng-deep .p-paginator .p-focus {
  outline: none !important;
  box-shadow: none !important;
}
.tabViewWrap {
  height: 100%;
  min-height: 0;
}
:host ::ng-deep .p-tabs {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .p-tablist {
  flex: 0 0 auto;
}
:host ::ng-deep .p-tabpanels {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}
:host ::ng-deep .p-tabpanel {
  height: 100%;
  min-height: 0;
  padding: 0 !important;
  flex-direction: column !important;
}
:host ::ng-deep .tabPanelGrid,
:host ::ng-deep .tabPanelFlex {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0 !important;
}
:host ::ng-deep .tableGrid,
:host ::ng-deep .tableFlexBody {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  min-width: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}
:host ::ng-deep p-table.tableHost {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  min-width: 0 !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}
:host ::ng-deep p-table.tableHost .p-datatable,
:host ::ng-deep p-table.tableHost .p-table {
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  min-width: 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
}
:host ::ng-deep p-table.tableHost .p-datatable-wrapper,
:host ::ng-deep p-table.tableHost .p-table-wrapper,
:host ::ng-deep p-table.tableHost .p-datatable-table-container {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow: auto !important;
}
:host ::ng-deep p-table.tableHost .p-datatable-table,
:host ::ng-deep p-table.tableHost .p-table-table,
:host ::ng-deep p-table.tableHost .p-datatable-table-container table,
:host ::ng-deep p-table.tableHost .p-table-wrapper table {
  min-width: 100% !important;
  width: max-content !important;
}
:host ::ng-deep p-table.tableHost .p-paginator {
  flex: 0 0 auto !important;
  width: 100% !important;
  margin: 0 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}
:host ::ng-deep p-table.tableHost .p-paginator .p-paginator-pages {
  display: inline-flex !important;
  align-items: center !important;
}
:host ::ng-deep p-table.tableHost .p-paginator .p-paginator-first,
:host ::ng-deep p-table.tableHost .p-paginator .p-paginator-prev,
:host ::ng-deep p-table.tableHost .p-paginator .p-paginator-next,
:host ::ng-deep p-table.tableHost .p-paginator .p-paginator-last,
:host ::ng-deep p-table.tableHost .p-paginator .p-paginator-pages,
:host ::ng-deep p-table.tableHost .p-paginator .p-dropdown,
:host ::ng-deep p-table.tableHost .p-paginator .p-select {
  flex: 0 0 auto !important;
}
:host ::ng-deep .tableTopBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 0 none;
  margin-top: 0 !important;
  padding-top: 2px !important;
  flex: 0 0 auto;
  padding: 2px 8px !important;
}
:host ::ng-deep .p-datatable-header {
  padding: 0 !important;
}
:host ::ng-deep .topbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
}
:host ::ng-deep .topbar-right {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}
:host ::ng-deep input.filterInput,
:host ::ng-deep input.filterInput:hover,
:host ::ng-deep input.filterInput:focus,
:host ::ng-deep input.filterInput:active,
:host ::ng-deep input.filterInput:focus-visible,
:host ::ng-deep input.filterInput.p-focus {
  font-size: 13px !important;
  font-weight: 400 !important;
  font-family: inherit !important;
  line-height: 1.2 !important;
  outline: none !important;
  box-shadow: none !important;
  -webkit-text-stroke: 0 !important;
  text-shadow: none !important;
}
:host ::ng-deep .tableTopBar .p-inputtext {
  font-size: 13px;
  padding: 4px 8px;
  height: 26px;
  line-height: 1.2;
  width: 180px;
}
:host ::ng-deep .myTextButton {
  display: flex;
  font-size: 13px !important;
}
:host ::ng-deep .col-button .p-button {
  background-color: transparent !important;
  color: #9cc9ad !important;
  border: 1px solid #9cc9ad !important;
}
:host ::ng-deep th.icon-col,
:host ::ng-deep td.icon-col {
  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
  padding: 0 !important;
  text-align: center !important;
  vertical-align: middle !important;
}
:host ::ng-deep .icon-btn.p-button {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  width: 32px !important;
  height: 28px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #8a8a8a !important;
}
:host ::ng-deep .icon-btn.p-button i,
:host ::ng-deep .icon-btn.p-button .pi {
  color: #8a8a8a !important;
  font-size: 13px !important;
  line-height: 1 !important;
}
:host ::ng-deep .icon-btn.p-button:hover {
  background: transparent !important;
  color: #666 !important;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-highlight,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-highlight > td,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-datatable-row-selected,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-datatable-row-selected > td,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr[aria-selected=true],
:host ::ng-deep .p-datatable .p-datatable-tbody > tr[aria-selected=true] > td {
  background: #ececec !important;
  color: inherit !important;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr:hover > td,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-selectable-row:hover,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-selectable-row:hover > td {
  background: #f3f3f3 !important;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-datatable-row-selected:hover,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr.p-datatable-row-selected:hover > td,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr[aria-selected=true]:hover,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr[aria-selected=true]:hover > td {
  background: #e0e0e0 !important;
}
:host ::ng-deep .p-paginator {
  margin: 0 !important;
  padding: 10px 6px !important;
  min-height: 20px !important;
  border: 0 !important;
}
:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 26px !important;
  height: 24px !important;
  line-height: 24px !important;
  padding: 0 6px !important;
  margin: 0 2px !important;
  font-size: 13px !important;
  border-radius: 3px !important;
}
:host ::ng-deep .p-paginator .p-paginator-first,
:host ::ng-deep .p-paginator .p-paginator-prev,
:host ::ng-deep .p-paginator .p-paginator-next,
:host ::ng-deep .p-paginator .p-paginator-last {
  width: auto !important;
  height: 24px !important;
  line-height: 24px !important;
  padding: 0 6px !important;
  margin: 0 2px !important;
  overflow: visible !important;
  text-indent: 0 !important;
  font-size: 13px !important;
  white-space: nowrap !important;
}
:host ::ng-deep .p-paginator .p-paginator-first > span,
:host ::ng-deep .p-paginator .p-paginator-prev > span,
:host ::ng-deep .p-paginator .p-paginator-next > span,
:host ::ng-deep .p-paginator .p-paginator-last > span {
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
  display: inline-block !important;
}
:host ::ng-deep .p-paginator .p-paginator-first::after {
  content: "PRVA";
}
:host ::ng-deep .p-paginator .p-paginator-prev::after {
  content: "PREJ\160NJA";
}
:host ::ng-deep .p-paginator .p-paginator-next::after {
  content: "NASLEDNJA";
}
:host ::ng-deep .p-paginator .p-paginator-last::after {
  content: "ZADNJA";
}
:host ::ng-deep .p-paginator .p-paginator-page.p-highlight,
:host ::ng-deep .p-paginator .p-paginator-pages .p-paginator-page[aria-current=page] {
  background: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
  color: #333 !important;
  box-shadow: none !important;
}
:host ::ng-deep .p-paginator .p-paginator-page:hover {
  background: #f3f3f3 !important;
}
:host ::ng-deep .p-paginator .p-paginator-page.p-highlight:hover {
  background: #dcdcdc !important;
}
:host ::ng-deep .p-paginator .p-select {
  height: 24px !important;
}
:host ::ng-deep .p-paginator .p-select .p-select-label {
  padding: 0 8px !important;
  line-height: 22px !important;
  font-size: 13px !important;
}
:host ::ng-deep .p-datatable .p-paginator,
:host ::ng-deep .p-table .p-paginator {
  margin: 0 !important;
  flex: 0 0 auto !important;
}
:host ::ng-deep .p-select-panel {
  background: #ffffff !important;
}
:host ::ng-deep .p-select-panel .p-select-item:hover {
  background: #f3f3f3 !important;
  color: #333 !important;
}
:host ::ng-deep .p-select-panel .p-select-item.p-highlight {
  background: #e6e6e6 !important;
  color: #333 !important;
}
:host ::ng-deep .p-select-panel .p-select-item.p-highlight:hover {
  background: #dcdcdc !important;
}
:host ::ng-deep .p-select-panel .p-select-item:focus,
:host ::ng-deep .p-select-panel .p-select-item.p-focus {
  outline: none !important;
  box-shadow: none !important;
}
:host ::ng-deep .tabHeaderInline {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  line-height: 1;
  font-size: 13px;
}
:host ::ng-deep .tabHeaderLoading {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  line-height: 1;
  margin-right: 6px;
  white-space: nowrap;
}
.globalLoaderOverlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.globalLoaderText {
  border: 1px solid #b2b2b2;
  padding: 12px 18px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}
:host ::ng-deep .detail-dialog .dialogScroll {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}
.infoTable {
  font-family:
    "Roboto",
    Arial,
    Helvetica,
    sans-serif;
  border-collapse: collapse;
  width: 100%;
}
.infoTable td,
.infoTable th {
  border: 1px solid #ddd;
  padding: 5px;
}
.infoTable tr:nth-child(even) {
  background-color: #f7f7f7 !important;
}
.infoTable th {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  background-color: #b2b2b2;
  color: white;
}
.infoTable td.attName,
.infoTable td.attValue {
  width: 50%;
}
.long-text-column {
  min-width: 200px;
}
.compact-tabs .p-tab {
  background: #f0f0f0;
  border: none;
  color: #5a5c5b;
  padding: 6px 10px;
}
.compact-tabs .p-tab.p-tab-active {
  background: #e0e0e0;
  color: #4a4a4a;
}
.compact-tabs .p-tablist {
  border-bottom: 1px solid #d6d6d6;
}
.compact-tabs .p-tab-close {
  border: none;
  background: transparent;
  opacity: 0.6;
  transition: 0.2s;
  cursor: pointer;
}
:host ::ng-deep .p-datatable-header,
:host ::ng-deep .p-table-header {
  padding-top: 0 !important;
  margin-top: 0 !important;
}
:host ::ng-deep .p-tablist-nav-content {
  overflow-x: auto !important;
  overflow-y: hidden !important;
}
:host ::ng-deep .p-tablist-nav {
  flex-wrap: nowrap !important;
}
:host ::ng-deep .compact-tabs .p-tab:hover,
:host ::ng-deep .compact-tabs .p-tab:focus,
:host ::ng-deep .compact-tabs .p-tab:active {
  background: #e6e6e6 !important;
  color: #4a4a4a !important;
  box-shadow: none !important;
}
:host ::ng-deep .compact-tabs .p-tab.p-tab-active:hover {
  background: #dcdcdc !important;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th,
:host ::ng-deep .p-table .p-table-thead > tr > th {
  background: #f0f0f0 !important;
  color: #333 !important;
  transition: background 0.15s;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th:hover,
:host ::ng-deep .p-sortable-column:hover,
:host ::ng-deep .p-column-header-content:hover {
  background: #e6e6e6 !important;
  color: #222 !important;
}
:host ::ng-deep .filesToolbar {
  margin: 6px 0 12px 0;
  padding: 10px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #fafafa;
}
.filesToolbarRow {
  display: flex;
  gap: 12px;
  align-items: end;
}
.filesToolbarCol {
  flex: 1 1 0;
  min-width: 0;
}
.filesLabel {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: #444;
}
:host ::ng-deep .filesSelect .p-select {
  height: 40px !important;
}
:host ::ng-deep .filesSelect .p-select-label {
  font-size: 13px !important;
  line-height: 38px !important;
  padding: 0 12px !important;
}
:host ::ng-deep .p-datatable-table,
:host ::ng-deep .p-table table {
  table-layout: auto !important;
}
:host ::ng-deep .p-table .p-table-thead > tr > th {
  padding: 4px 8px !important;
  vertical-align: middle !important;
  font-size: 13px !important;
  line-height: 1.1 !important;
  white-space: normal !important;
}
:host ::ng-deep .p-table .p-table-tbody > tr > td {
  padding: 4px 6px !important;
  vertical-align: top !important;
  line-height: 1.05 !important;
}
:host ::ng-deep th.col-auto,
:host ::ng-deep td.col-auto {
  width: auto !important;
  min-width: 140px !important;
  max-width: 520px;
}
:host ::ng-deep .cellClamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  line-height: 1.15;
}
:host ::ng-deep .headerClamp {
  line-height: 1.1;
}
:host ::ng-deep .thHeaderFlex {
  display: flex !important;
  align-items: center !important;
  width: 100%;
  gap: 8px;
  min-width: 0;
}
:host ::ng-deep .thHeaderTitle {
  flex: 1 1 auto;
  min-width: 0;
}
:host ::ng-deep .thSortIcon {
  margin-left: auto !important;
  flex: 0 0 auto !important;
  white-space: nowrap;
}
:host ::ng-deep .thHeaderFlex .p-sortable-column-icon {
  margin-left: auto !important;
  flex: 0 0 auto !important;
}
:host ::ng-deep .p-table .p-table-thead > tr > th,
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  border-right: 1px solid #d6d6d6 !important;
}
:host ::ng-deep .p-table .p-table-thead > tr > th:last-child,
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th:last-child {
  border-right: 0 !important;
}
:host ::ng-deep .p-table .p-table-tbody > tr > td,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
  border-right: 1px solid #eeeeee !important;
}
:host ::ng-deep .p-table .p-table-tbody > tr > td:last-child,
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td:last-child {
  border-right: 0 !important;
}
:host ::ng-deep p-table.tableHost .p-datatable-table-container {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  min-width: 0 !important;
  display: block !important;
}
:host ::ng-deep .remote-power-dialog .p-dialog {
  width: clamp(720px, 70vw, 980px) !important;
  max-width: 96vw !important;
}
:host ::ng-deep .remote-power-dialog .p-dialog-header {
  padding: 4px 24px !important;
  font-size: 18px !important;
}
:host ::ng-deep .remote-power-dialog .p-select,
:host ::ng-deep .remote-power-dialog .p-dropdown,
:host ::ng-deep .remote-power-dialog .p-inputtext {
  height: 44px !important;
}
:host ::ng-deep .remote-power-dialog .p-select-label,
:host ::ng-deep .remote-power-dialog .p-dropdown-label {
  line-height: 42px !important;
  font-size: 14px !important;
}
:host ::ng-deep .remote-power-dialog button.p-button {
  height: 44px !important;
  padding: 0 18px !important;
  font-size: 14px !important;
}
:host ::ng-deep .remote-power-dialog .p-button {
  width: 100% !important;
}
:host ::ng-deep .remote-power-dialog .p-dialog {
  height: auto !important;
}
:host ::ng-deep .remote-power-dialog .p-dialog-content {
  padding: 22px 24px !important;
  height: auto !important;
  min-height: 0 !important;
  padding-bottom: 16px !important;
}
:host ::ng-deep .remote-power-dialog .p-dialog-content > * {
  flex: 0 0 auto;
}
:host ::ng-deep body .p-select-overlay .p-select-option.p-highlight {
  background: #e6e6e6 !important;
  color: #333 !important;
}
.uploadProgressWrap {
  margin-top: 14px;
  margin-bottom: 14px;
}
:host ::ng-deep .uploadProgressWrap .p-progressbar {
  height: 14px !important;
  border-radius: 8px !important;
  overflow: hidden;
}
:host ::ng-deep .uploadProgressWrap .p-progressbar-value {
  background: #89bf98 !important;
}
:host ::ng-deep .unified-popup.p-dialog,
:host ::ng-deep .unified-popup.p-confirmdialog {
  border-radius: 18px !important;
  overflow: hidden !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18) !important;
  border: 1px solid #e6e6e6 !important;
  background: #fff !important;
}
:host ::ng-deep .unified-popup .p-dialog-header,
:host ::ng-deep .unified-popup .p-confirm-dialog .p-dialog-header {
  background: #fbfbfb !important;
  border: 0 !important;
  border-bottom: 1px solid #ececec !important;
  padding: 10px 18px !important;
  min-height: 48px !important;
  border-top-left-radius: 18px !important;
  border-top-right-radius: 18px !important;
}
:host ::ng-deep .unified-popup .p-dialog-title,
:host ::ng-deep .unifiedPopupTitle {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #213754 !important;
  line-height: 1.1 !important;
}
:host ::ng-deep .unified-popup .p-dialog-header-actions,
:host ::ng-deep .unified-popup .p-dialog-header-icons {
  gap: 0 !important;
}
:host ::ng-deep .unified-popup .p-dialog-header-close,
:host ::ng-deep .unified-popup .p-dialog-header-icon,
:host ::ng-deep .unified-popup .p-dialog-header-actions .p-button {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  padding: 0 !important;
}
:host ::ng-deep .unified-popup .p-dialog-header-close .pi,
:host ::ng-deep .unified-popup .p-dialog-header-icon .pi,
:host ::ng-deep .unified-popup .p-dialog-header-actions .p-button .pi {
  font-size: 18px !important;
  color: #4b5d73 !important;
}
:host ::ng-deep .unified-popup .p-dialog-content {
  padding: 26px 28px 18px 28px !important;
  background: #fff !important;
}
:host ::ng-deep .unified-popup .p-dialog-footer {
  padding: 0 28px 28px 28px !important;
  background: #fff !important;
  border-top: 0 !important;
  border-bottom-left-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
}
.unifiedPopupBody {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.unifiedPopupMessage {
  font-size: 15px;
  color: #3c4c63;
  line-height: 1.4;
}
.unifiedFieldRow {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 !important;
}
.unifiedFieldRow label {
  margin: 0 !important;
  font-size: 16px;
  font-weight: 400;
  color: #3c4c63;
  white-space: nowrap;
}
:host ::ng-deep .unifiedFieldRow .p-inputtext {
  width: 100% !important;
  height: 42px !important;
  border-radius: 6px !important;
  font-size: 15px !important;
}
.unifiedPopupFooter {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
:host ::ng-deep .unifiedPopupBtn.p-button {
  min-width: 132px !important;
  height: 46px !important;
  border-radius: 6px !important;
  font-size: 16px !important;
  box-shadow: none !important;
  background: #ececec !important;
  border: 1px solid #d8d8d8 !important;
  color: #4b5d73 !important;
}
:host ::ng-deep .unifiedPopupBtn.p-button:hover,
:host ::ng-deep .unifiedPopupBtn.p-button:focus,
:host ::ng-deep .unifiedPopupBtn.p-button:active {
  background: #e5e5e5 !important;
  border-color: #d0d0d0 !important;
  color: #4b5d73 !important;
  box-shadow: none !important;
}
:host ::ng-deep .docTreeFileClickable {
  cursor: pointer;
  text-decoration: underline;
}
:host ::ng-deep .docPreviewFrame {
  width: 100%;
  height: 100%;
  border: 0;
}
:host ::ng-deep .docPreviewImage {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}
:host ::ng-deep .docPreviewFallback {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
:host ::ng-deep .previewDialogClean {
  margin: 0 !important;
  max-height: none !important;
  border: 0 !important;
  box-shadow: none !important;
}
:host ::ng-deep .previewDialogClean .p-dialog-content {
  padding: 0 !important;
  height: 100% !important;
  overflow: hidden !important;
  background: #fff !important;
  border-radius: 0 !important;
}
:host ::ng-deep .previewDialogClean.p-dialog {
  max-height: none !important;
}
:host ::ng-deep .previewShell {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .previewToolbar {
  height: 56px;
  min-height: 56px;
  background: #333;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 0 24px;
}
:host ::ng-deep .previewTitle {
  font-weight: 600;
  font-size: 15px;
  color: #fff;
}
:host ::ng-deep .previewActions {
  display: flex;
  align-items: center;
  gap: 6px;
}
:host ::ng-deep .previewIconBtn {
  width: 36px !important;
  height: 36px !important;
  background: transparent !important;
  border: 0 !important;
  color: #fff !important;
  box-shadow: none !important;
}
:host ::ng-deep .previewIconBtn:hover {
  background: rgba(255, 255, 255, 0.12) !important;
}
:host ::ng-deep .previewCloseBtn:hover {
  background: rgba(255, 80, 80, 0.25) !important;
}
:host ::ng-deep .previewBody {
  flex: 1;
  min-height: 0;
  background: #fff;
  overflow: hidden;
}
:host ::ng-deep .docPreviewFrame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #fff;
}
:host ::ng-deep .docPreviewImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #fff;
}
:host ::ng-deep .docPreviewFallback {
  width: 100%;
  height: 100%;
  color: #222;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
:host ::ng-deep .previewDialogFullscreen.p-dialog {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100dvh !important;
  max-width: 100vw !important;
  max-height: 100dvh !important;
  margin: 0 !important;
  transform: none !important;
  border-radius: 0 !important;
}
:host ::ng-deep .previewDialogFullscreen .p-dialog-content {
  width: 100% !important;
  height: 100% !important;
  max-height: 100dvh !important;
  padding: 0 !important;
  overflow: hidden !important;
}
:host ::ng-deep .previewDialogFullscreen .previewShell {
  width: 100% !important;
  height: 100% !important;
}
:host ::ng-deep .previewDialogFullscreen .previewBody {
  flex: 1 1 auto !important;
  min-height: 0 !important;
}
:host ::ng-deep .clickableCell {
  text-decoration: underline;
  cursor: pointer;
}
:host ::ng-deep .changeInfo {
  margin-top: 4px;
  padding-left: 8px;
  border-left: 2px solid #d0d0d0;
  color: #666;
  font-size: 11px;
  line-height: 1.25;
}
:host ::ng-deep .changeInfo b {
  color: #444;
}
:host ::ng-deep .changeNoteBox {
  margin: 12px 0 8px 0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
:host ::ng-deep .changeNoteBox label {
  min-width: 95px;
  color: #34445a;
  font-size: 12px;
  line-height: 32px;
}
:host ::ng-deep .changeNoteTextarea {
  width: 260px;
  min-height: 48px;
  resize: none;
  border: 1px solid #d8dde6;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  color: #34445a;
  background: #fff;
  outline: none;
  font-family: inherit;
}
:host ::ng-deep .changeNoteTextarea:focus {
  border-color: #9fb4cc;
  box-shadow: 0 0 0 2px rgba(159, 180, 204, 0.18);
}
:host ::ng-deep .changeNoteTextarea::placeholder {
  color: #8c98a8;
}
:host ::ng-deep .saveNoteRow {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 0 0 0;
}
:host ::ng-deep .changeNoteBox {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
:host ::ng-deep .changeNoteBox label {
  color: #34445a;
  font-size: 14px;
  white-space: nowrap;
}
:host ::ng-deep .changeNoteInput {
  flex: 1;
  height: 32px;
  min-width: 0;
  border: 1px solid #d8dde6;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 14px;
  color: #34445a;
  background: #fff;
  outline: none;
  font-family: inherit;
}
:host ::ng-deep .changeNoteInput:focus {
  border-color: #9fb4cc;
  box-shadow: 0 0 0 2px rgba(159, 180, 204, 0.18);
}
:host ::ng-deep .changeNoteInput::placeholder {
  color: #8c98a8;
}
:host ::ng-deep .saveDetailBtn {
  height: 38px;
  white-space: nowrap;
}
:host ::ng-deep .editInputRow {
  display: flex;
  align-items: center;
  gap: 6px;
}
:host ::ng-deep .noteIconBtn.p-button {
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #8a8a8a !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
:host ::ng-deep .noteIconBtn.p-button:hover {
  background: #f3f3f3 !important;
  border-radius: 4px;
  color: #5f5f5f !important;
}
:host ::ng-deep .noteIconBtn.p-button .pi {
  font-size: 14px !important;
}
:host ::ng-deep .noteIconBtn.hasNote.p-button {
  color: #296cb4 !important;
}
:host ::ng-deep .detailSavePane {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 18px;
  margin-top: 18px;
  padding-top: 8px;
}
:host ::ng-deep .saveDetailBtn.p-button {
  min-width: 96px;
}
:host ::ng-deep .historyExpand {
  margin-top: 5px;
  font-size: 12px;
  cursor: pointer;
  color: #34445a;
  text-decoration: underline;
}
:host ::ng-deep .historyList {
  margin-top: 6px;
  padding: 6px;
  background: #f7f7f7;
  border-left: 2px solid #bfc7d1;
}
:host ::ng-deep .historyEntry {
  padding-bottom: 6px;
  margin-bottom: 6px;
  border-bottom: 1px solid #ddd;
}
:host ::ng-deep .historyEntry:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
:host ::ng-deep .historyExpand {
  margin-top: 5px;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  color: #8c8c8c;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  -webkit-user-select: none;
  user-select: none;
}
:host ::ng-deep .historyExpand:hover {
  color: #6f6f6f;
  text-decoration: none;
}
:host ::ng-deep .detailDialogHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
:host ::ng-deep .detailHeaderClose {
  border: none;
  background: transparent;
  color: #34445a;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
}
:host ::ng-deep .detailHeaderClose:hover {
  color: #000;
}
:host ::ng-deep .editInputRow {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}
:host ::ng-deep .editFieldInput {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
:host ::ng-deep .noteIconBtn {
  flex: 0 0 30px;
  width: 30px !important;
  height: 30px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}
.docTreeMain[draggable=true] {
  cursor: grab;
}
.docTreeMain[draggable=true]:active {
  cursor: grabbing;
}
.docTreeRow {
  min-height: 34px;
  padding: 4px 8px;
}
.docTreeRow.docDropTarget {
  cursor: pointer;
}
.docTreeRow.docDraggingOver {
  outline: 2px dashed #777;
  background: #f2f2f2;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th.col-auto {
  background: var(--header-color, #f0f0f0) !important;
  padding: 4px 8px !important;
  vertical-align: middle !important;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th.col-auto > .thHeaderFlex {
  background: transparent !important;
  padding: 0 !important;
  width: 100%;
  box-sizing: border-box;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th[rowspan="2"] {
  vertical-align: middle !important;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th.groupHeaderCell {
  background: var(--group-color, #f0f0f0) !important;
  padding: 4px 8px !important;
  text-align: center !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  line-height: 1.15 !important;
  white-space: nowrap;
  border-right: 1px solid #d6d6d6 !important;
  vertical-align: middle !important;
  filter: brightness(0.94);
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th.col-auto:hover {
  background: var(--header-color, #e6e6e6) !important;
  filter: brightness(0.96);
}
:host ::ng-deep .izkazniceCell {
  max-height: 66px;
  overflow-y: auto;
  font-size: 12px;
  line-height: 1.35;
}
:host ::ng-deep .izkaznicaVrstica {
  padding: 1px 0;
}
/*# sourceMappingURL=table.component.css.map */
